import React, { useEffect, useState } from 'react';
import { TiWarningOutline } from 'react-icons/ti';
import WarningDialog from './WarningDialog3';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
// TiWarningOutline

const Augest23 = () => {
  const navigate = useNavigate();
  const [showCopy, setShowCopy] = useState(false);
  const [showSubmit, setShowSubmit] = useState(false);
  const [showError, setShowError] = useState(false);
  const [utr, setUtr] = useState('');
  const { id } = useParams();
  const data = JSON.parse(atob(id));

  const handleCopy = (data) => {
    navigator.clipboard.writeText(data);
    setShowCopy(true);
    setTimeout(() => {
      setShowCopy(false);
    }, 2000);
  };

  const handleSubmit = () => {
    if (utr.length === 12) {
      setShowSubmit(true);
      return setTimeout(() => {
        setShowSubmit(false);
      }, 2000);
    }
    setShowError(true);
    setTimeout(() => {
      // setShowError(false);
      setShowError(false);
    }, 2000);
  };

  useEffect(() => {
    document.title = data?.ap;
    if (data?.e < moment().unix()) return navigate('/expire');
  }, [navigate, data?.e, data?.ap]);

  return (
    <div className={'w-100 h-100 text-initial p-2'}>
      {showCopy && <div className={'animate-copy'}>Copied</div>}
      {showSubmit && (
        <div className={'animate-copy'}>Submitted Successfully</div>
      )}
      {showError && (
        <div className={'animate-copy'} style={{ background: '#ff000099' }}>
          UTR must be 12
        </div>
      )}
      <div style={{ border: '1px dashed rgb(144, 144, 214)' }}>
        <div
          className='d-flex justify-between p-05'
          style={{
            background: 'rgb(42, 181, 255)',
            color: '#fff',
            margin: '2px'
          }}
        >
          <p
            style={{
              fontSize: '15px',
              color: 'white',
              backgroundColor: 'rgb(42, 181, 255)',
              padding: '8px',
              margin: '2px'
            }}
          >
            Step1: Copy Amount and Bank Account information
          </p>
        </div>
        <div
          className='d-flex justify-between px-3 py-2'
          style={{ borderBottom: '1px solid lightgray' }}
        >
          <h1 className='augest-h1'>Amount</h1>
          <div className='d-flex gap-3'>
            <p className={'augest-p'}>₹{data?.a}</p>
            <button
              className={'augest-copy-btn'}
              onClick={() => handleCopy(data.a)}
            >
              copy
            </button>
          </div>
        </div>
        <div
          className='d-flex justify-between px-3 py-2'
          style={{ borderBottom: '1px solid lightgray' }}
        >
          <h1 className='augest-h1'>Name</h1>
          <div className='d-flex gap-3'>
            <p className={'augest-p'}>{data?.u}</p>
            <button
              className={'augest-copy-btn'}
              onClick={() => handleCopy(data.u)}
            >
              copy
            </button>
          </div>
        </div>
        <div
          className='d-flex justify-between px-3 py-2'
          style={{ borderBottom: '1px solid lightgray' }}
        >
          <h1 className='augest-h1'>VPA/UPI</h1>
          <div className='d-flex gap-3'>
            <p className={'augest-p'}>{data?.up}</p>
            <button
              className={'augest-copy-btn'}
              onClick={() => handleCopy(data.up)}
            >
              copy
            </button>
          </div>
        </div>
        <div
          className='d-flex justify-between px-3 py-2'
          style={{ borderBottom: '1px solid lightgray' }}
        >
          <h1 className='augest-h1'>Expiry Time</h1>
          <div className='d-flex gap-3'>
            <p className={'augest-p'}>
              {moment.unix(data?.e).format('YYYY-MM-DD HH:mm:ss')}
            </p>
          </div>
        </div>
      </div>

      <div
        style={{ border: '1px dashed rgb(144, 144, 214)', marginTop: '2rem' }}
      >
        <div
          className='d-flex justify-between p-05'
          style={{
            background: 'rgb(42, 181, 255)',
            color: '#fff',
            margin: '2px'
          }}
        >
          <p
            style={{
              fontSize: '15px',
              color: 'white',
              backgroundColor: 'rgb(42, 181, 255)',
              padding: '8px',
              margin: '2px'
            }}
          >
            Step2:Transfer and don't modify this amount to us.
          </p>
        </div>
        <div
          className='d-flex justify-between px-3 py-2'
          style={{ borderBottom: '1px solid lightgray' }}
        >
          <p
            style={{ fontSize: '12px', color: 'rgb(85, 85, 127)' }}
            className={'d-flex align-center'}
          >
            <TiWarningOutline
              style={{ color: 'rgb(255, 85, 0)', fontSize: '15px' }}
            />
            {'Please record your reference No. {Ref No.} after payment'}
          </p>
        </div>
      </div>

      <div
        style={{ border: '1px dashed rgb(144, 144, 214)', marginTop: '2rem' }}
      >
        <div
          className='d-flex justify-between p-05'
          style={{
            background: 'rgb(42, 181, 255)',
            color: '#fff',
            margin: '2px'
          }}
        >
          <p
            style={{
              fontSize: '15px',
              color: 'white',
              backgroundColor: 'rgb(42, 181, 255)',
              padding: '8px',
              margin: '2px'
            }}
          >
            Step3:Please enter Ref No. to complete the recharge
          </p>
        </div>
        <div
          className=' px-3 py-2'
          style={{ borderBottom: '1px solid lightgray' }}
        >
          <p
            style={{ fontSize: '12px', color: 'rgb(85, 85, 127)' }}
            className={'d-flex align-center'}
          >
            <TiWarningOutline
              style={{ color: 'rgb(255, 85, 0)', fontSize: '15px' }}
            />
            {
              'Be sure to return this page to fill the UTR numbers after you have completed you payment'
            }
          </p>
          <input
            placeholder={'UTR (UPI Ref.ID) must be 12 digits'}
            className={'w-100 no-borderInput'}
            onChange={(e) => setUtr(e.target.value)}
            value={utr}
          />
        </div>
      </div>

      <button className={'augest-submit-btn'} onClick={handleSubmit}>
        Submit UTR
      </button>
      <WarningDialog />
    </div>
  );
};

export default Augest23;

// *After you paid, you must come back here to submit the Ref/UTR No.(12 digits) .then your money is credited to your account.
